import React from "react";
import "../../App.scss";
import { updateState } from "../StateHelper";
import { Button, Modal, Form, Row } from "react-bootstrap";
import AuthorizedPage from "../../component/AuthorizedPage";
import AdminBasketApi from "../../api/AdminBasketApi";
import BuyerWarehouseApi from "../../api/BuyerWarehouseApi";
import { Role } from "../../domain/Role";

const initialState = {
  baskets: [],
  selectedBuyerId: null,
  selectedBasketId: null,
  buyerRequestReferenceCodeModalDisplay: false,
  buyerRequestReferenceCodeRelatedBuyerId: null,
  buyerRequestReferenceCode: null,
  buyerWarehouses: [],

  // Eksik olan state eklendi
  buyerWarehousesForSelectedBuyer: [],

  // Tarih state'i (YYYY-MM-DD formatında görsel input için)
  plannedShipmentDate: "",
  // Backend için tam format (ISO)
  plannedShipmentDateISOString: "",
  description: ""
};

const colorGroup = [
  { key: "red", value: "Kırmızı" },
  { key: "yellow", value: "Sarı" },
  { key: "blue", value: "Mavi" },
  { key: "purple", value: "Mor" },
  { key: "gray", value: "Gri" }
];

class AdminBasketManagement extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = initialState;
    this.applyToOrder = this.applyToOrder.bind(this);
    this.onBuyerRequestReferenceCodeSubmit = this.onBuyerRequestReferenceCodeSubmit.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  init() {
    this.loadBaskets();
    this.loadBuyerWarehouses();
  }

  refresh() {
    this.setState(initialState);
    this.init();
  }

  async loadBaskets() {
    let response = await AdminBasketApi.listAll();
    if (response.success) {
      updateState(this, "baskets", response.data);
    }
  }

  async loadBuyerWarehouses() {
    let response = await BuyerWarehouseApi.listAllBuyerWarehouses();
    if (response.success) {
      updateState(this, "buyerWarehouses", response.data);
    }
  }

  async applyToOrder(buyerId: any, basketId: any, buyerRequestReferenceCode?: any, buyerWarehouseId?: any, plannedShipmentDate?: any, colorGroup?: any, description?: any) {
    const body = {
      buyerId: buyerId,
      basketId: basketId,
      buyerRequestReferenceCode: buyerRequestReferenceCode,
      buyerWarehouseId: buyerWarehouseId,
      plannedShipmentDate: plannedShipmentDate,
      colorGroup: colorGroup,
      description: description
    };

    let response = await AdminBasketApi.applyToOrderWithBody(body);

    if (response.success) {
      this.refresh();
      // Başarılıysa modalı kapat
      updateState(this, "buyerRequestReferenceCodeModalDisplay", false);
    } else {
      // 🔥 FIX: TypeScript'i susturmak için 'any' cast işlemi
      const res = response as any;

      let errorMsg = "Bir hata oluştu";

      // 1. Durum: { error: { message: "..." } } - Backend'in gönderdiği yapı
      if (res.error && res.error.message) {
          errorMsg = res.error.message;
      }
      // 2. Durum: { message: "..." }
      else if (res.message) {
          errorMsg = res.message;
      }
      // 3. Durum: { error: "..." } - String formatı
      else if (typeof res.error === "string") {
          errorMsg = res.error;
      }

      window.alert(errorMsg);
    }
  }

  // Modal Açılırken Çalışan Fonksiyon
  async onBuyerRequestReferenceCodeEntry(buyerId: any, basketId: any) {
    updateState(this, "buyerRequestReferenceCodeModalDisplay", true);
    updateState(this, "buyerRequestReferenceCodeRelatedBuyerId", buyerId);
    updateState(this, "selectedBasketId", basketId);

    // --- TARİH AYARLAMASI ---
    const now = new Date();
    // Yerel saati koruyarak YYYY-MM-DD oluşturuyoruz
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const todayStr = `${year}-${month}-${day}`;

    updateState(this, "plannedShipmentDate", todayStr);

    // Backend için ISO (Zamanı şimdiki zaman olarak gönderiyoruz)
    updateState(this, "plannedShipmentDateISOString", now.toISOString());
    // -------------------------------------

    const response = await BuyerWarehouseApi.listBuyerWarehouses(buyerId);
    if (response.success) {
      updateState(this, "buyerWarehousesForSelectedBuyer", response.data);
    }
  }

  async onBuyerRequestReferenceCodeSubmit(e: any) {
    e.preventDefault();
    const data = new FormData(e.target as HTMLFormElement);
    this.applyToOrder(
      data.get("buyerRequestReferenceCodeRelatedBuyerId"),
      data.get("selectedBasketId"),
      data.get("buyerRequestReferenceCode"),
      data.get("buyerWarehouseId"),
      data.get("plannedShipmentDateISOString"), // Gizli inputtan gelen ISO format
      data.get("colorGroup"),
      data.get("description")
    );
  }

  buyerRequestReferenceCodeModal = () => {
    let colorGroupOptions = colorGroup.map((e: any) => {
      return <option key={e.key} value={e.key}>{e.value}</option>;
    });

    return (
      <Modal
        size="lg"
        autoFocus={true}
        show={this.state.buyerRequestReferenceCodeModalDisplay}
        onHide={() => updateState(this, "buyerRequestReferenceCodeModalDisplay", false)}
        dialogClassName="modal-70w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sipariş Oluştur</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="centered-85-percent">
            <Form onSubmit={this.onBuyerRequestReferenceCodeSubmit}>

              {/* Gizli Inputlar */}
              <div style={{ display: "none" }}>
                <Form.Control name="buyerRequestReferenceCodeRelatedBuyerId" type="text" defaultValue={this.state.buyerRequestReferenceCodeRelatedBuyerId || ""} />
                <Form.Control name="selectedBasketId" type="text" defaultValue={this.state.selectedBasketId || ""} />
                <Form.Control name="plannedShipmentDateISOString" type="text" value={this.state.plannedShipmentDateISOString || ""} readOnly />
              </div>

              <Form.Group className="mb-4" controlId="buyerRequestReferenceCode">
                <Form.Label>Müşteri Talep Referans Kodu</Form.Label>
                <Form.Control name="buyerRequestReferenceCode" type="text" placeholder="Müşteri Talep Referans Kodu" defaultValue={this.state.buyerRequestReferenceCode || ""} />
              </Form.Group>

              {/* --- TARİH SEÇİCİ (HTML5) --- */}
              <Form.Group className="mb-4" controlId="plannedShipmentDate">
                <Form.Label>Planlanan Sevkiyat Tarihi</Form.Label>
                <Form.Control
                  type="date"
                  name="plannedShipmentDate_visual"
                  value={this.state.plannedShipmentDate || ""}
                  onChange={(e) => {
                    const dateStr = e.target.value;
                    updateState(this, "plannedShipmentDate", dateStr);

                    if (dateStr) {
                      const isoDate = new Date(dateStr).toISOString();
                      updateState(this, "plannedShipmentDateISOString", isoDate);
                    } else {
                      updateState(this, "plannedShipmentDateISOString", null);
                    }
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-4" controlId="buyerWarehouseId">
                <Form.Label>Hedef Müşteri Deposu</Form.Label>
                <Form.Select name="buyerWarehouseId">
                  <option value="">Depo Seçiniz</option>
                  {this.state.buyerWarehousesForSelectedBuyer?.map((w: any) => (
                    <option key={w.id} value={w.id}>{w.title}</option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-4" controlId="colorGroup">
                <Form.Label>Sipariş Renk Etiketi</Form.Label>
                <Form.Select name="colorGroup">
                  <option value="">Sipariş Renk Etiketi Seçiniz</option>
                  {colorGroupOptions}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-4" controlId="description">
                <Form.Label>Sipariş Açıklaması</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  placeholder="Sipariş ile ilgili açıklama giriniz"
                  defaultValue={this.state.description || ""}
                />
              </Form.Group>

              <Row className="mb-4">
                <Button type="submit" value="Submit" variant="warning">Siparişi Oluştur</Button>
              </Row>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  async onAction(actionType: any, actionData: any) {
    if ("DELETE" == actionType) {
      let response = await AdminBasketApi.delete(actionData.id, {
        buyerId: actionData.buyerId,
      });
      if (response.success) {
        this.refresh();
      } else {
        // 🔥 FIX: Silme işlemi için de TypeScript ve Hata Mesajı düzeltmesi
        const res = response as any;
        let errorMsg = "Silme işlemi başarısız";

        if (res.error && res.error.message) {
            errorMsg = res.error.message;
        } else if (res.message) {
            errorMsg = res.message;
        } else if (res.error) {
            errorMsg = res.error;
        }
        window.alert(errorMsg);
      }
    }
  }

  renderBaskets = () => {
    return (
      this.state.baskets &&
      this.state.baskets.map((item: any, index: number) => {
        let basketItems = this.renderBasketItems(item.basketItems);
        return (
          <div
            key={index}
            className="row basket-border"
            style={{ marginTop: "35px", paddingTop: "16px" }}
          >
            <div className="row" style={{ marginBottom: "15px" }}>
              <div className="col-md-8">
                <h4>{item.buyer.title || ""} {item.buyer.name || ""} ({item.buyer.code}) - Sepet No: {item.basketId}</h4>
              </div>
              <div className="col-md-4 text-end">
                <Button variant="outline-danger">Sepeti İptal Et</Button>
                <Button
                  variant="success"
                  style={{ marginLeft: "15px" }}
                  onClick={() => this.onBuyerRequestReferenceCodeEntry(item.buyer.id, item.basketId)}>
                  Sipariş Geç
                </Button>
              </div>
            </div>
            {basketItems}
          </div>
        );
      })
    );
  };

  renderBasketItems = (basketItems: any) => {
    return (
      basketItems &&
      basketItems.map((item: any, index: number) => {
        return (
          <div key={index} className="row" style={{ marginBottom: "12px" }}>
            <hr />
            <div className="row">
              <div className="col-md-7">
                <div>
                  {item.product.name}
                </div>
              </div>
              <div className="col-md-3 justify-content-center align-self-center">
                <span>Koli Adet: {item.boxQuantity}</span>
              </div>
              <div className="col-md-2 text-end justify-content-center align-self-center">
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    this.onAction("DELETE", item);
                  }}
                >
                  Sil
                </Button>
              </div>
            </div>
          </div>
        );
      })
    );
  };

  render() {
    const baskets = this.renderBaskets();
    const buyerRequestReferenceCodeModal = this.buyerRequestReferenceCodeModal();
    return (
      <AuthorizedPage role={Role.ORDER_MANAGER}>
        {buyerRequestReferenceCodeModal}
        <div className="centered-99-percent">
          {baskets}
        </div>
      </AuthorizedPage>
    );
  }
}

export default AdminBasketManagement;